<ng-template #content let-modal>

    <div *ngIf="loader === 'content'" [ngClass]="(styling.sharedStyle$ | async)" [ngClass]="(styling.savedFont)">
        <div class="modal-header w-20 ">
            <h3 class="header-title m-0 p-0">Accesibilitate</h3>
        </div>
            <!-- start:Font size selectors -->

            <div class="font-weight-boldest font-select-text text-center pt-10"><p class="m-0">Schimbă dimensiunea textului</p></div>
    <div class="d-flex align-items-center justify-content-around flex-wrap flex-sm-nowrap p-20">
            <button type="button" class="increase-font-size-btn font-weight-bold" (click)="initialFont()">
                    <i class="fas fa-font"></i>
            </button>
            <button type="button" class="increase-font-size-btn font-weight-bold" (click)="incFont1()">
                    <i class="fas fa-font big-font"></i>
            </button>
            <button type="button" class="increase-font-size-btn font-weight-bold" (click)="incFont2()">
                <i class="fas fa-font very-big-font"></i>
            </button>
    </div>

    <!-- end:Font size selectors -->
    </div>

</ng-template>


<button class="floating-btn" (click)="openVerticallyCentered(content)">
    <!-- <i class="fas fa-eye"></i> -->
    <i class="fas fa-universal-access"></i>
</button>
